module.exports = __webpack_public_path__ + "static/media/team-alice.cea7e248.webp";